import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Dropdown from "react-dropdown";
import "react-dropdown/style.css";
import i18n from "i18next";
import Cookies from "js-cookie";
import logo from "../img/logo.png";

function Header() {
  const location = useLocation();
  const { t } = useTranslation();

  const languages = [
    { value: "en", label: "EN" },
    { value: "ru", label: "RU" },
    { value: "de", label: "DE" },
    { value: "es", label: "ES" },
    { value: "it", label: "IT" },
  ];

  const storedLang = Cookies.get("i18next");
  const [currentLang, setCurrentLang] = useState(storedLang || "en");
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    if (storedLang && storedLang !== currentLang) {
      setCurrentLang(storedLang);
      i18n.changeLanguage(storedLang);
    }
    document.body.setAttribute("dir", storedLang === "ar" ? "rtl" : "ltr");
  }, [storedLang]);

  const handleChangeLang = (selectedLang) => {
    setCurrentLang(selectedLang.value);
    i18n.changeLanguage(selectedLang.value);
    Cookies.set("i18next", selectedLang.value);
  };

  useEffect(() => {
    const isMobile = window.innerWidth <= 768;

    const handleScroll = () => {
      if (isMobile) {
        setIsScrolled(true);
        document.body.classList.add("scrolled");
        return;
      }

      const y = window.scrollY;
      setIsScrolled(y > 200);

      if (y > 200) document.body.classList.add("scrolled");
      else document.body.classList.remove("scrolled");
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll();

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    if (location.pathname === "/consultation") {
      document.body.classList.add("consultation-page");
    } else {
      document.body.classList.remove("consultation-page");
    }
  }, [location.pathname]);

  useEffect(() => {
    const handleScroll = () => {
      const y = window.scrollY;
      if (location.pathname === "/about-us" && y <= 200) {
        document.body.classList.add("about-us-page");
      } else {
        document.body.classList.remove("about-us-page");
      }
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll();

    return () => window.removeEventListener("scroll", handleScroll);
  }, [location.pathname]);

  const getLinkClass = (path) => {
    // На главной странице и на /about-us до скролла — белый текст
    if ((location.pathname === "/" || (location.pathname === "/about-us" && !isScrolled)) && !isScrolled) {
      return "text-[#FFFFFFB2]";
    }

    if (location.pathname === path) {
      return "text-[#FC2E00]";
    }

    return "text-[#000000B2]";
  };

  const getHeaderBackground = () => {
    if (!isScrolled) {
      if (location.pathname === "/about-us" || location.pathname === "/") return "transparent";
      return "linear-gradient(90deg, rgba(255,255,255,0.20) 0%, rgba(255,255,255,0.00) 100%)";
    }
    return "#FFF";
  };

  return (
    <div className="header-container fixed top-0 left-0 w-full z-50">
      <div
        className="max-w-[1220px] h-[60px] xl:h-[72px] justify-between mx-auto flex items-center px-[20px] transition-colors duration-1000"
        style={{ background: getHeaderBackground() }}
      >
        <Link to="/">
          <img src={logo} alt="logo" className="w-[32px] xl:w-[54px]" />
        </Link>

        <div className="flex items-center gap-[20px]">
          <Link to="/about-us">
            <p className={`text-[16px] texttt font-[500] host-grotesk transition-all ${getLinkClass("/about-us")}`}>
              {t("header.1")}
            </p>
          </Link>

          <Link to="/consultation">
            <p className={`text-[16px] texttt font-[500] host-grotesk transition-all ${getLinkClass("/consultation")}`}>
              {t("header.2")}
            </p>
          </Link>

          <Dropdown
            options={languages}
            placeholder="EN"
            onChange={handleChangeLang}
            value={languages.find((lang) => lang.value === currentLang)}
          />
        </div>
      </div>
    </div>
  );
}

export default Header;
